import { a as arAE } from './ar-AE-CxXG3gd4.js';
import { d as deDE } from './de-DE-BffIX9aW.js';
import { e as enAU } from './en-AU-DGGK0Lgs.js';
import { e as enCA } from './en-CA-BkRk1H--.js';
import { e as enGB } from './en-GB-Bo4DMKCX.js';
import { e as enIN } from './en-IN-Qhg6eAuK.js';
import { e as enSG } from './en-SG-DiNuNzW6.js';
import { e as enUS } from './en-US-DsQA0Y_c.js';
import { e as esCO } from './es-CO-CFlVHWMC.js';
import { e as esES } from './es-ES-Dpvpwv0L.js';
import { e as esMX } from './es-MX-DdQqS9d9.js';
import { f as frCA } from './fr-CA-DsQSz1XU.js';
import { f as frFR } from './fr-FR-Bov978eS.js';
import { h as hiIN } from './hi-IN-DcfCtl8u.js';
import { i as itIT } from './it-IT-B04xf_Ur.js';
import { j as jaJP } from './ja-JP-CdhJHumO.js';
import { k as koKR } from './ko-KR-Cov7CBt9.js';
import { n as nlNL } from './nl-NL-D01PDT6h.js';
import { p as plPL } from './pl-PL-BQBO4wOV.js';
import { p as ptBR } from './pt-BR-Bx9S7HFh.js';
import { s as svSE } from './sv-SE-D7mzFbvC.js';
import { t as taIN } from './ta-IN-CGYMjUny.js';
import { t as thTH } from './th-TH-CcG7aYO6.js';
import { t as trTR } from './tr-TR-DdfmFkCz.js';
import { v as viVN } from './vi-VN-CzuQrWbf.js';
import { z as zhCN } from './zh-CN-B5d6GPwL.js';
import { z as zhTW } from './zh-TW-DVSfHBRV.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
/**
 * Imports for translations
 */
const translationComps = {
  'ar-AE': arAE,
  'de-DE': deDE,
  'en-AU': enAU,
  'en-CA': enCA,
  'en-GB': enGB,
  'en-IN': enIN,
  'en-SG': enSG,
  'en-US': enUS,
  'es-CO': esCO,
  'es-ES': esES,
  'es-MX': esMX,
  'fr-CA': frCA,
  'fr-FR': frFR,
  'hi-IN': hiIN,
  'it-IT': itIT,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'nl-NL': nlNL,
  'pl-PL': plPL,
  'pt-BR': ptBR,
  'sv-SE': svSE,
  'ta-IN': taIN,
  'th-TH': thTH,
  'tr-TR': trTR,
  'vi-VN': viVN,
  'zh-CN': zhCN,
  'zh-TW': zhTW
};
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : enUS,
    locale: locale && locale in translationComps ? locale : 'en-US'
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=static-SL0AuvKM.js.map
